import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M4.013 5.94v1.927c0 .406-.173 1.026-.38 1.373l-.766 1.273c-.474.787-.147 1.66.72 1.954 2.873.96 5.973.96 8.846 0a1.335 1.335 0 0 0 .72-1.954l-.766-1.273c-.2-.347-.374-.967-.374-1.373V5.94c0-2.2-1.8-4-4-4-2.206 0-4 1.793-4 4Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.607 2a4.502 4.502 0 0 0-1.827.133 1.324 1.324 0 0 1 2.467 0A4.037 4.037 0 0 0 8.607 2Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M10.013 12.707c0 1.1-.9 2-2 2a2.007 2.007 0 0 1-2-2"
    />
  </svg>
)
export default SvgComponent
